<template>
	<aside>
		<compFormEdit
			col="1"
			ref="accountform"
			class="margin-layout"
			:formdata="getBase"
			v-model="formData"
		></compFormEdit>
		<vButtonGroup class="text-right margin-top-15">
			<vButton theme="primary" @click="submit">确定</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</aside>
</template>
<script>
import { HttpBillManageList, HttpSaveAdjustAccount } from '@/service/costbilling';
// import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
			loading: false,
			formData: {},
			billList: [],
		};
	},
	created() {
		this.getReconList()
	},
	computed: {
		getBase() {
			return [
				{
					label: '账单编号',
					tag: 'vSelect',
					key: 'billNo',
					options: this.billList,
					on: {
						'on-attach': attach => this.formData = { ...this.formData, ...attach }
					},
					props: {
                        filterable: true,
                    }
				},
				{
					label: '组织',
					key: 'organizationName',
					query: true,
				},
				// {
				// 	label: '仓库',
				// 	key: 'warehouseCode',
				// 	query: true,
				// },
				{
					label: '账期',
					key: 'month',
					query: true,
				},
				{
					label: '调账类型',
					tag: 'vSelect',
					key: 'type',
					options: this.getAdjutmentType
				},
				{
					label: '费用类型',
					tag: 'vSelect',
					key: 'billingType',
					options: this.getCostType,
					required: false,
				},
				{
					label: '计费单号',
					tag: 'vInput',
					key: 'billingOrderNo',
				},
				{
					label: '调账金额',
					tag: 'vInputNumber',
					key: 'amount',
					span: 22,
					props:{
						min:0
					}
				},
				{
					tag: 'div',
					labelWidth: 5,
					children: 'USD',
					query: true,
					span: 2,
				},
				{
					label: '调账说明',
					tag: 'vTextarea',
					key: 'remark',
				},
			]
		},

	},
	methods: {
		getReconList() {
			this.loading = true
			HttpBillManageList({
				page: 1,
				rows: 1000,
				sidx: 'id',
				sord: 'desc',
				'search[EQ_billStatus]': 0
			}).then(res => {
				this.loading = false
				this.billList = res.data.content.map(item => {
					return {
						value: item.billNo,
						label: item.billNo,
						attach: {
							organizationName: item.organizationName,
							warehouseCode: item.warehouseCode,
							month: item.billingDate,
							organizationId: item.organizationId,
							orgWarehouseId: item.orgWarehouseId,
							warehouseId: item.warehouseId,
						}
					}
				})
			}, err => {
				this.loading = false
				this.$VMessage.error(err.message);
			})
		},
		close() {
			this.$emit('on-close')
		},
		async submit() {
			const valid = await this.$refs['accountform'].validate();
			if (!valid) return;
			this.loading = true
			HttpSaveAdjustAccount(this.formData).then(res => {
				this.$VMessage.success(res.message);
				this.close();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
